import { FormatCurrency, FormatNumber } from './IntlUtils';
export function getFormattedValue(value, isCurrency, currencyCode, skipSummarization, locale) {
    if (isNaN(value)) {
        return '';
    }
    if (skipSummarization) {
        return intlFormat(value, isCurrency, currencyCode);
    }
    if (value >= 1000 && value < 100000) {
        var truncatedValue = Number((value / 1000).toFixed(1));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'K';
    }
    if (value >= 100000 && value < 1000000) {
        var truncatedValue = Number((value / 1000).toFixed(0));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'K';
    }
    if (value >= 1000000 && value < 100000000) {
        var truncatedValue = Number((value / 1000000).toFixed(1));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'M';
    }
    if (value >= 100000000 && value < 1000000000) {
        var truncatedValue = Number((value / 1000000).toFixed(0));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'M';
    }
    if (value >= 1000000000 && value < 100000000000) {
        var truncatedValue = Number((value / 1000000000).toFixed(1));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'B';
    }
    if (value >= 100000000000) {
        var truncatedValue = Number((value / 1000000000).toFixed(0));
        return intlFormat(truncatedValue, isCurrency, currencyCode, locale) + 'B';
    }
    return intlFormat(value, isCurrency, currencyCode, locale);
}
function intlFormat(value, isCurrency, currencyCode, locale) {
    return isCurrency ? FormatCurrency(value, currencyCode, locale) : FormatNumber(value);
}
//# sourceMappingURL=NumberFormatUtils.js.map